var _vars = require('./vars')._vars;
var _html = require('./html')._html;

var currentProvider = null;

function getProvider() {
    return Promise.resolve('dify');
}

function getCurrentProvider() {
    return currentProvider;
}

function initProvider() {
    return getProvider().then(function(provider) {
        _vars.provider = provider;
        return new Promise(function(resolve, reject) {
            try {
                var module = require('./providers/dify');
                currentProvider = module;
                resolve(module);
            } catch (error) {
                console.error('Failed to load dify provider:', error);
                reject(error);
            }
        });
    });
}

function showErrorModal(message) {
	if (document.querySelector('.ai-search-full-width-container') != null) {
		// Remove existing error modal if present
		var existingModal = document.getElementById('ai-search-error-modal');
		if (existingModal) {
			existingModal.remove();
		}

		// Create and append new error modal
		var modalHTML = _html.errorModal(message);
		document.body.insertAdjacentHTML('beforeend', modalHTML);

		// Add event listeners for closing the modal
		var modal = document.getElementById('ai-search-error-modal');
		var closeBtn = modal.querySelector('.error-modal-close');
		var okBtn = modal.querySelector('.error-modal-ok-btn');
		var overlay = modal.querySelector('.error-modal-overlay');

		function closeModal() {
			modal.remove();
		}

		closeBtn.addEventListener('click', closeModal);
		okBtn.addEventListener('click', closeModal);
		overlay.addEventListener('click', function(e) {
			if (e.target === overlay) {
				closeModal();
			}
		});
	} else {
		document.body.insertAdjacentHTML('beforeend', '<style>body.article-ai-search-active #article-ai-search-fab, #article-ai-search-fab {display: none !important;}</style>');
	}
}

module.exports = {
    initProvider: initProvider,
    getProvider: getProvider,
    getCurrentProvider: getCurrentProvider
};